import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { deleteSer } from "./../../actions";
import AdmPhSerSingleNav from './AdmPhSerSingleNav';

const mapStateToProps = null;
const mapDispatchToProps = (dispatch) => ({
    deleteSer: (payload) => dispatch(deleteSer(payload))
});

const phSEl = ({ item, deleteSer }) => {
  return (<div style={{ float: 'left', marginTop: '1em', width: '100%', lineHeight: '1.5em' }}>
        <AdmPhSerSingleNav item={ item } />
        <br />  
        <span>
            {item.name}
        </span>
        <br />     
        <span onClick={() => window.confirm('Obrisati stavku?') ? deleteSer(item.id) : ''} style={{marginLeft: '0%', cursor: 'pointer', color: 'darkgrey'}}>
            obriši
        </span>

    </div>);
}

export default connect(mapStateToProps, mapDispatchToProps)(phSEl);
